import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalComponent } from '../../shared/components/modals/modal/modal.component';
import { forkJoin } from "rxjs";
import { ConfirmationDocument, Discipline, DisciplineClient, EducationalProgram, EducationalProgramClient, EducationForm, EntranceExam, EntranceExamClient, FileClient, Person, PersonClient, ProfileDescription, ProfileDescriptionClient, ProgramArea, ProgramAreaClient, ProgramProfile, ProgramProfileClient, Section, SectionClient, Work, WorkClient } from 'src/app/services/apis/web-api-client';
import { FileService } from 'src/app/services/file.service';
import { GetConfirmationDocumentType } from 'src/app/models/enums/confirmation-document';
import { GetEducationForms } from 'src/app/models/enums/education-form';

@Component({
  selector: 'app-educational-program',
  templateUrl: './educational-program.component.html',
  styleUrls: ['./educational-program.component.scss']
})
export class EducationalProgramComponent implements OnInit {
  modalRef: BsModalRef;
  id;
  isLoaded: boolean = true;
  // programLeader: Person;
  program: EducationalProgram = null;
  section: Section;
  exams: Array<EntranceExam> = [];
  examsInProgram: Array<EntranceExam> = [];

  programProfiles: Array<ProgramProfile> = [];
  programProfilesInProgram: Array<ProgramProfile> = [];

  programAreas: Array<ProgramArea> = [];

  profileDescriptions: Array<ProfileDescription> = [];

  works: Array<Work> = [];
  worksInProgram: Array<Work> = [];

  disciplines: Array<Discipline> = [];
  disciplinesInProgram: Array<Discipline> = [];

  teachers: Array<Person> = [];
  teachersInProgram: Array<Person> = [];


  constructor(
    private modalService: BsModalService,
    private personService: PersonClient,
    private activateRoute: ActivatedRoute,
    private educationProgram: EducationalProgramClient,
    private sectionService: SectionClient,
    private entranceExamsService: EntranceExamClient,
    private programProfileService: ProgramProfileClient,
    private programAreaService: ProgramAreaClient,
    private workService: WorkClient,
    private disciplineService: DisciplineClient,
    private fileService: FileService,
    private profileDescriptionService: ProfileDescriptionClient,
  ) {

  }

  ngOnInit(): void {
    this.id = this.activateRoute.snapshot.params['id'];
    forkJoin({
      eduProgram: this.educationProgram.getOne(this.id),
      programAreas: this.programAreaService.getAll(),
      profDescription: this.profileDescriptionService.getAll(),
      exams: this.entranceExamsService.getAll(),
      works: this.workService.getAll(),
      teachers: this.personService.getAll(),
      disciplines: this.disciplineService.getAll(),
      programProfile: this.programProfileService.getAll(),

    }).subscribe(value => {
      this.program = value.eduProgram;
      forkJoin({
        section: this.sectionService.getOne(value.eduProgram.sectionId),
        // programLeader: this.personService.getOne(value.eduProgram.personId)
      }).subscribe(value1 => {
        this.section = value1.section;
        // this.programLeader = value1.programLeader;
        this.programAreas = value.programAreas;
        this.profileDescriptions = value.profDescription;
        this.exams = value.exams
        this.works = value.works;
        this.teachers = value.teachers;
        this.disciplines = value.disciplines;
        this.programProfiles = value.programProfile;


        this.examsInProgram = [];
        this.program.entranceExams.forEach(
          examsHalf => {
            this.exams.forEach(
              examsFull => {
                if (examsHalf.entranceExamId === examsFull.id) {
                  this.examsInProgram.push(examsFull);
                }
              }
            );
          }
        );

        this.worksInProgram = [];
        this.program.works.forEach(
          workHalf => {
            this.works.forEach(
              workFull => {
                if (workHalf.workId === workFull.id) {
                  this.worksInProgram.push(workFull);
                }
              }
            );
          }
        );

        this.teachersInProgram = [];
        this.program.teachers.forEach(
          teachersCut => {
            this.teachers.forEach(
              teachersFull => {
                if (teachersCut.personId === teachersFull.id) {
                  this.teachersInProgram.push(teachersFull);
                }
              }
            );
          }
        );

        this.disciplinesInProgram = [];
        this.program.disciplines.forEach(
          disciplineCut => {
            this.disciplines.forEach(
              disciplineFull => {
                if (disciplineCut.disciplineId === disciplineFull.id) {
                  this.disciplinesInProgram.push(disciplineFull);
                }
              }
            );
          }
        );

        this.programProfilesInProgram = [];
        this.program.programProfiles.forEach(
          programProfileCUT => {
            this.programProfiles.forEach(
              ProgramProfileFULL => {
                if (programProfileCUT.programProfileId === ProgramProfileFULL.id) {
                  this.programProfilesInProgram.push(ProgramProfileFULL);
                }
              }
            );
          }
        );
        this.isLoaded = false;
      })
    }
    )
  }


  compareAreasName(id: string) {
    //TODO: Происходит повторное обращение к данным (влияет на производительность)
    let result = this.programAreas.find(value => value.id == id).name;
    return result;
  }

  compareDescription(id: string) {
    let result = this.profileDescriptions.find(value => value.id == id).content;
    return result;
  }

  compareAreasImage(id: string) {
    //TODO: Происходит повторное обращение к данным (влияет на производительность)
    let result = this.programAreas.find(value => value.id == id).pictureId;
    return result;
  }

  compareDescriptionImage(id: string) {
    //TODO: Происходит повторное обращение к данным (влияет на производительность)
    let result = this.profileDescriptions.find(value => value.id == id).pictureId;
    return result;
  }

  downloadFile(id: string) {
    if (id) {
      return this.fileService.getDownloadUrl(id);
      return "/assets/user.png";
    } else {
      return "/assets/user.png";
    }
  }

  openModal() {
    this.modalRef = this.modalService.show(ModalComponent);
    this.modalRef.content.programId = this.program.id;

  }

  getConfirmationDocumentType(type: ConfirmationDocument) {
    return GetConfirmationDocumentType(type);
  }

  getEducationForm(form: EducationForm) {
    return GetEducationForms(form);
  }
}
